import capitalize from 'lodash/capitalize';
import React from 'react';
import { Link as RouteLink } from 'react-router-dom';
import { Cell } from "../CloudConversions/CloudConversionsTableData";
import ViewReportIcon from "../Common/ViewReportIcon";
export const FeedbackDetailsHeader = {
  cells: [{
    key: 'date',
    content: 'Feedback date',
    style: {
      minWidth: '95px'
    }
  }, {
    key: 'licenseId',
    content: 'License ID',
    style: {
      minWidth: '135px'
    }
  }, {
    key: 'appName',
    content: 'App name'
  }, {
    key: 'appVersion',
    content: 'App version',
    style: {
      minWidth: '120px'
    }
  }, {
    key: 'action',
    content: 'Action'
  }, {
    key: 'reason',
    content: 'Reason',
    style: {
      minWidth: '300px'
    }
  }]
};
export const getFeedbackDetailsBody = (feedbackDetails, getReportsLink, onViewFeedbackClick) => feedbackDetails.map(feedback => ({
  key: feedback.licenseId,
  cells: [{
    key: feedback.date,
    content: /*#__PURE__*/React.createElement(Cell, null, feedback.date)
  }, {
    key: feedback.licenseId,
    content: /*#__PURE__*/React.createElement(RouteLink, {
      to: getReportsLink('text', feedback.licenseId, 'licenseId')
    }, feedback.licenseId)
  }, {
    key: feedback.addonName,
    content: /*#__PURE__*/React.createElement(RouteLink, {
      to: getReportsLink('addon', feedback.addonKey)
    }, feedback.addonName)
  }, {
    key: feedback.addonVersion,
    content: feedback.addonVersion
  }, {
    key: feedback.feedbackType,
    content: capitalize(feedback.feedbackType)
  }, {
    key: feedback.reason,
    content: /*#__PURE__*/React.createElement(ViewReportIcon, {
      columnValue: feedback.reason,
      onClick: _ => onViewFeedbackClick(feedback)
    })
  }]
}));